import { render, staticRenderFns } from "./BotConfiguration.vue?vue&type=template&id=a72578be&scoped=true&"
import script from "./BotConfiguration.vue?vue&type=script&lang=js&"
export * from "./BotConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BotConfiguration.vue?vue&type=style&index=0&id=a72578be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72578be",
  null
  
)

export default component.exports